// @flow
import React from 'react';
import './ModalDialog.css';
import Modal from 'react-modal';
import type {Element} from 'react';

export type Props = {
  show: boolean,
  onClose: Function,
  className?: string,
  showCloseButton?: boolean,
  onOpen?: Function,
  children?: number | string | Element<*> | Array<any>,
  size?: string,
};

const ModalDialog = ({
  show,
  onClose,
  onOpen,
  children,
  className = '',
  showCloseButton = false,
  size = 'small',
}: Props) => (
  <div className="ModalDialog">
    <Modal
      isOpen={show}
      contentLabel="Modal"
      overlayClassName="modal-overlay"
      className={`modal modal-${size} ${className}`}
      onRequestClose={onClose}
      onAfterOpen={() => onOpen && onOpen()} >
      {showCloseButton &&
        <button
          onClick={onClose}
          className="close-button">
          <span>&times;</span>
        </button>
      }
      {children}
    </Modal>
  </div>
);

export default ModalDialog;



// WEBPACK FOOTER //
// ./src/components/ModalDialog/ModalDialog.js